import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#64748B",
  d: "M12.667 4.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M12.667 10.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M12.667 16.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M6.833 4.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M6.833 10.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M6.833 16.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#64748B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12.667 4.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M12.667 10.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M12.667 16.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M6.833 4.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M6.833 10.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M6.833 16.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }